import fetchHandler from './Handler';

// export const newsLetterAPI = async (data: any) => {
//     try {
//         const response = await fetchHandler({
//             method: 'POST',
//             endpoint: 'GetAllCategories',
//             data,
//         });
//         return response;
//     } catch (error) {
//         console.error('Unexpected error:', error);
//     }
// };

// export const changeAddressStatus = async (data: any) => {
//     try {
//         const response = await fetchHandler({
//             method: 'PUT',
//             endpoint: '/users/shipping-address',
//             data,
//         });
//         return response;
//     } catch (error) {
//         console.error('Unexpected error:', error);
//     }
// };

export const getAllCategories = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: '/user/categeory',
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};

export const getSingleCategorySubproducts = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `/user/subcategory/category/${data}`,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};

export const userEnquiryApi = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: '/user/inquiry',
			data,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};

export const getDefaultMenu = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: '/user/defaultmenu',
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
export const getAllEvents = async () => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: '/user/eventtype',
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
export const getSelectedEventList = async (id: string) => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `/user/eventtype/${id}/menuTypes`,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
